import { DistributionType } from "@/services/cloudchipr.api";

export const dimensionMaxCharacter = 255;

export const dimensionIdSearchParam = "dimensionId";
export const dimensionEditActiveTab = "activeTab";

export const sharedCostDistributionTypeLabels: Record<
  DistributionType,
  string
> = {
  manual: "Manual Allocation",
  even: "Even Split",
};
